// phonics_data_tt.js
// Song/Chant 来源: F:\BaiduNetdiskDownload\Phonics\tt.mp4 (用户指定，时间段 00:11~01:36)
// Story 1/2/3 来源: F:\17talkxyz\Phonics_AtoZ\Letter Tt\Tt1/Tt2/Tt3.mp4 (完整)

const MEDIA_BASE = '/media/phonics/tt';

const letterDataTt = {
  letter: 'Tt',
  coverBg: `${MEDIA_BASE}/image1.jpeg`,
  coverPoster: `${MEDIA_BASE}/Tt.png`,

  songVideo: {
    src: `${MEDIA_BASE}/Tt.mp4`,
    poster: `${MEDIA_BASE}/Tt.png`,
    startTime: 11,
    endTime: 96,
  },

  wordVideos: [
    { src: `${MEDIA_BASE}/video_s3_word1.mp4`, poster: `${MEDIA_BASE}/image8.png`, word: 'top', wordCn: '陀螺' },
    { src: `${MEDIA_BASE}/video_s3_word2.mp4`, poster: `${MEDIA_BASE}/image9.png`, word: 'taxi', wordCn: '出租车' },
    { src: `${MEDIA_BASE}/video_s3_word3.mp4`, poster: `${MEDIA_BASE}/image10.png`, word: 'tomato', wordCn: '番茄' },
    { src: `${MEDIA_BASE}/video_s3_word4.mp4`, poster: `${MEDIA_BASE}/image11.png`, word: 'tent', wordCn: '帐篷' },
  ],

  storySections: [
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_top.mp4`, poster: `${MEDIA_BASE}/image13.png` },
      ],
      splitAt: 4,
      lines: [
        {
          en: 'to',
          cn: '去，前往',
          audioEn: `${MEDIA_BASE}/w_en_to.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_to.mp3`,
        },
        {
          en: 'toy',
          cn: '玩具',
          audioEn: `${MEDIA_BASE}/w_en_toy.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_toy.mp3`,
        },
        {
          en: 'toy store',
          cn: '玩具商店',
          audioEn: `${MEDIA_BASE}/w_en_toy_store.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_toy_store.mp3`,
        },
        {
          en: 'please',
          cn: '请',
          audioEn: `${MEDIA_BASE}/w_en_please.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_please.mp3`,
        },
        {
          en: 'Turtle wants a top.',
          cn: '海龟需要一个陀螺。',
          audioEn: `${MEDIA_BASE}/story1_en_1.mp3`,
          audioCn: `${MEDIA_BASE}/story1_cn_1.mp3`,
        },
        {
          en: 'Taxi. To the toy store, please!',
          cn: '出租车，请送我去玩具商店！',
          audioEn: `${MEDIA_BASE}/story1_en_2.mp3`,
          audioCn: `${MEDIA_BASE}/story1_cn_2.mp3`,
        },
      ],
    },
    {
      label: 'Learn the Story (2)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_market.mp4`, poster: `${MEDIA_BASE}/image14.png` },
      ],
      splitAt: 3,
      lines: [
        {
          en: 'need',
          cn: '需要',
          audioEn: `${MEDIA_BASE}/w_en_need.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_need.mp3`,
        },
        {
          en: 'needs',
          cn: '需要（第三人称）',
          audioEn: `${MEDIA_BASE}/w_en_needs.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_needs.mp3`,
        },
        {
          en: 'market',
          cn: '市场',
          audioEn: `${MEDIA_BASE}/w_en_market.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_market.mp3`,
        },
        {
          en: 'Turtle needs a tomato.',
          cn: '海龟需要一个番茄。',
          audioEn: `${MEDIA_BASE}/story2_en_1.mp3`,
          audioCn: `${MEDIA_BASE}/story2_cn_1.mp3`,
        },
        {
          en: 'Taxi. To the market, please!',
          cn: '出租车，请送我去市场！',
          audioEn: `${MEDIA_BASE}/story2_en_2.mp3`,
          audioCn: `${MEDIA_BASE}/story2_cn_2.mp3`,
        },
      ],
    },
    {
      label: 'Learn the Story (3)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_lake.mp4`, poster: `${MEDIA_BASE}/image15.png` },
      ],
      splitAt: 1,
      lines: [
        {
          en: 'lake',
          cn: '湖',
          audioEn: `${MEDIA_BASE}/w_en_lake.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_lake.mp3`,
        },
        {
          en: 'Turtle has a tent.',
          cn: '海龟有一个帐篷。',
          audioEn: `${MEDIA_BASE}/story3_en_1.mp3`,
          audioCn: `${MEDIA_BASE}/story3_cn_1.mp3`,
        },
        {
          en: 'Taxi. To the lake, please!',
          cn: '出租车，请送我去湖边！',
          audioEn: `${MEDIA_BASE}/story3_en_2.mp3`,
          audioCn: `${MEDIA_BASE}/story3_cn_2.mp3`,
        },
      ],
    },
  ],
};

export default letterDataTt;
